import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { InvoiceEvents } from 'src/app/extensions/services/api/events';
import { InvoiceAPIService } from 'src/app/extensions/services/api/invoice-api.service';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';
import { LoaderService } from 'src/app/extensions/services/loader.service';
import { DetailsListModalComponent } from 'src/app/extensions/components/details-list-modal/details-list-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TIMEOUT_EVENT_TYPE } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.scss'],
  standalone: false,
})
export class InvoiceDetailComponent implements OnInit {
  public constructor(
    private _activatedRoute: ActivatedRoute,
    private _invoiceAPIService: InvoiceAPIService,
    private _location: Location,
    private _notificationService: NotificationService,
    private _fileStoreAPIService: FileStoreAPIService,
    private _translateService: TranslateService,
    private _loaderService: LoaderService,
    private _ngbModal: NgbModal
  ) {}

  public invoiceId: string;
  public invoice: app.models.GetInvoiceModel;
  public props: app.models.DynamicPropsDictionary;

  public ngOnInit(): void {
    this.invoiceId = this._activatedRoute.snapshot.params['invoiceId'];

    this._invoiceAPIService.getInvoice(this.invoiceId).subscribe(x => {
      this.invoice = x.data;
      this.props = x.props;
    });
  }

  public backHandler() {
    this._location.back();
  }

  showClipboardNotification() {
    this._notificationService.showSuccess(
      this._translateService.instant('common.copiedToClipboard'),
      this._translateService.instant('common.success')
    );
  }

  exportPDFHandler() {
    this._loaderService.isLoadingForced.next(true);
    this._invoiceAPIService.getInvoiceFile(this.invoiceId).subscribe(result => {
      if (result.isSuccess) {
        const event = result.response.events.find(x => x.eventType == InvoiceEvents.InvoiceFileSaved);
        if (event.eventBody) {
          //Download is trigger by signalR
        }
      } else if (result.response.events.some(x => x.eventType == TIMEOUT_EVENT_TYPE)) {
        this._notificationService.showInfo(
          this._translateService.instant('invoice.exportLongTimeWarning'),
          this._translateService.instant('common.warning')
        );
      } else {
        this._notificationService.showError(
          this._translateService.instant('invoice.exportFailed'),
          this._translateService.instant('common.error')
        );
      }
      this._loaderService.isLoadingForced.next(false);
    });
  }

  public openDetailsListModalInvoiceContracts = (e: Event, dataList: any[]) => {
    e.stopPropagation();
    const modal = this._ngbModal.open(DetailsListModalComponent, { backdrop: 'static', scrollable: true });
    modal.componentInstance.modalTitle = 'invoice.detailsListModalTitle.contracts';
    modal.componentInstance.dataList = dataList.map(item => item.contractNumber);
  };
}
